import * as types from '../../action-types';

export default wallet => ({
  type: types.SET_NEWPAY_WALLET,
  wallet,
});
